import { ApolloLink } from '@apollo/client';
import { SentryLink } from 'apollo-link-sentry';

const sentryLink = new SentryLink({
  attachBreadcrumbs: {
    includeError: true,
    includeQuery: true,
    includeVariables: true,
  },
});

// Migration variables contain a verification code and the user's new password.
export default ApolloLink.split(
  ({ operationName }) =>
    ['CompleteAccountMigration', 'RequestAccountMigration'].includes(
      operationName,
    ),
  new ApolloLink((operation, forward) => forward(operation)),
  sentryLink,
);
